import React, { ReactNode } from 'react'
import Input from '@UI/antd/Input/Input'
import Form from 'antd/lib/form'
import styles from './index.scss'

interface IProps {
    label?: string
    name: string | [string, number]
    required?: boolean
    requiredMsg?: string
    rules?: any
    formatter?: any
    parser?: any
    min?: number
    max?: number
    onChange?: any
    suffix?: ReactNode
    theme?: 'theme-1' | 'theme-2'
    disabled?: boolean
}
const InputNumberField = (props: IProps) => {
    const {
        label = '',
        name,
        required = false,
        requiredMsg = '',
        rules = [],
        formatter = null,
        parser = null,
        min = 1,
        max,
        onChange = undefined,
        suffix = null,
        theme = 'theme-1',
        disabled = false
    } = props
    return (
        <div className={styles['suffix-container']}>
            <div className={styles[theme]}>
                {theme === 'theme-2' && (
                    <Form.Item noStyle shouldUpdate={(prev, next) => prev !== next}>
                        {({ getFieldValue, setFieldValue }) => (
                            <span
                                onClick={() => {
                                    const value = getFieldValue(name) || 0
                                    if (value > min) {
                                        setFieldValue(name, value - 1)
                                    }
                                }}
                            >
                                -
                            </span>
                        )}
                    </Form.Item>
                )}
                <Form.Item
                    name={name}
                    rules={[
                        {
                            required: required,
                            message: requiredMsg || `Please enter ${label}`
                        },
                        ...rules
                    ]}
                    hasFeedback={suffix ? false : true}
                >
                    <Input.Number
                        className={styles['input-number']}
                        label={label + (required ? ' *' : '')}
                        formatter={formatter}
                        parser={parser}
                        min={min}
                        max={max}
                        onChange={onChange}
                        disabled={disabled}
                    />
                </Form.Item>
                {theme === 'theme-2' && (
                    <Form.Item noStyle shouldUpdate={(prev, next) => prev !== next}>
                        {({ getFieldValue, setFieldValue }) => (
                            <span
                                onClick={() => {
                                    const value = getFieldValue(name) || 0
                                    if (value < max) {
                                        setFieldValue(name, value + 1)
                                    }
                                }}
                            >
                                +
                            </span>
                        )}
                    </Form.Item>
                )}
            </div>
            {suffix && <span className={styles['suffix-wrapper']}>{suffix}</span>}
        </div>
    )
}

export default InputNumberField
